export default __webpack_public_path__ + "static/media/44.46523e18.svg";